var _circle, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#52D783"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.77148,
    y: 14.2559,
    width: 9.29032,
    height: 1.99078,
    rx: 0.995392,
    transform: "rotate(-37.414 7.77148 14.2559)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.51172,
    y: 19.4678,
    width: 5.97235,
    height: 1.32719,
    rx: 0.663594,
    transform: "rotate(-127.414 7.51172 19.4678)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82935,
    y: 18.46,
    width: 5.97235,
    height: 1.32719,
    rx: 0.663594,
    transform: "rotate(-127.414 8.82935 18.46)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8657,
    y: 11.5234,
    width: 5.97235,
    height: 1.32719,
    rx: 0.663594,
    transform: "rotate(-127.414 17.8657 11.5234)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1833,
    y: 10.5156,
    width: 5.97235,
    height: 1.32719,
    rx: 0.663594,
    transform: "rotate(-127.414 19.1833 10.5156)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrength);
export default __webpack_public_path__ + "static/media/strength.0c3ef0739782c2521f8a3be2e12b5444.svg";
export { ForwardRef as ReactComponent };